import parse from 'html-react-parser';
import { Fragment } from 'react';

import RouterLink from '~components/generic/RouterLink';
import { ChevronRightIcon } from '~components/icons/ChevronRightIcon';
import { BreadcrumbItem } from '~components/search/BreadcrumbItem';

export function SearchResultListItem({ title, snippet, url, pathPages }: SearchResultsItem) {
  return (
    <div className="ebm--result-list-item">
      <div className="breadcrumb ml-3 bg-white text-sm p-2 leading-none inline-flex items-center">
        {pathPages.length > 0 ? (
          pathPages.map((path, idx) => (
            <Fragment key={idx}>
              {idx > 0 ? <ChevronRightIcon className="w-4 h-4 mx-1" /> : null}
              <BreadcrumbItem {...path} />
            </Fragment>
          ))
        ) : (
          <BreadcrumbItem title={title} url={url} />
        )}
      </div>
      <RouterLink to={url} className="block no-underline transition hover:shadow-md font-sans text-black">
        <div className="content bg-white p-3">
          <div className="text-lg font-bold mb-2">{title}</div>
          <div className="text-base">{parse(snippet)}</div>
        </div>
      </RouterLink>
    </div>
  );
}
